"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var directionMap = new Map();
directionMap.set('ltr', 'row');
directionMap.set('rtl', 'row-reverse');
directionMap.set('ttb', 'column');
directionMap.set('btt', 'column-reverse');
var wrapMap = new Map();
wrapMap.set(true, 'wrap');
wrapMap.set(false, 'nowrap');
wrapMap.set('reverse', 'wrap-reverse');
var justifyMap = new Map();
justifyMap.set('start', 'flex-start');
justifyMap.set('end', 'flex-end');
justifyMap.set('center', 'center');
justifyMap.set('between', 'space-between');
justifyMap.set('around', 'space-around');
var alignItemsMap = new Map();
alignItemsMap.set('start', 'flex-start');
alignItemsMap.set('end', 'flex-end');
alignItemsMap.set('center', 'center');
alignItemsMap.set('baseline', 'baseline');
alignItemsMap.set('stretch', 'stretch');
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: function flexDirection(_ref) {
        var dir = _ref.dir;
        return directionMap.get(dir);
      },
      justifyContent: function justifyContent(_ref2) {
        var center = _ref2.center,
            justify = _ref2.justify;
        return center ? 'center' : justifyMap.get(justify);
      },
      alignItems: function alignItems(_ref3) {
        var center = _ref3.center,
            _alignItems = _ref3.alignItems;
        return center ? 'center' : alignItemsMap.get(_alignItems);
      },
      flexWrap: function flexWrap(_ref4) {
        var wrap = _ref4.wrap;
        return wrapMap.get(wrap);
      },
      width: function width(_ref5) {
        var fullWidth = _ref5.fullWidth;
        return fullWidth ? '100%' : 'auto';
      },
      height: function height(_ref6) {
        var center = _ref6.center;
        return center ? '100%' : 'auto';
      }
    }
  };
});

var Flex = /*#__PURE__*/_react.default.forwardRef(function (_ref7, ref) {
  var _ref7$children = _ref7.children,
      children = _ref7$children === void 0 ? null : _ref7$children,
      _ref7$dir = _ref7.dir,
      dir = _ref7$dir === void 0 ? 'ltr' : _ref7$dir,
      _ref7$justify = _ref7.justify,
      justify = _ref7$justify === void 0 ? 'start' : _ref7$justify,
      _ref7$alignItems = _ref7.alignItems,
      alignItems = _ref7$alignItems === void 0 ? 'start' : _ref7$alignItems,
      _ref7$wrap = _ref7.wrap,
      wrap = _ref7$wrap === void 0 ? false : _ref7$wrap,
      center = _ref7.center,
      fullWidth = _ref7.fullWidth,
      className = _ref7.className,
      props = _objectWithoutProperties(_ref7, ["children", "dir", "justify", "alignItems", "wrap", "center", "fullWidth", "className"]);

  var classes = useStyles({
    dir: dir,
    justify: justify,
    alignItems: alignItems,
    wrap: wrap,
    center: center,
    fullWidth: fullWidth
  });
  return /*#__PURE__*/_react.default.createElement(_core.Box, _extends({
    className: (0, _clsx.default)(classes.root, className),
    ref: ref
  }, props), children);
});

Flex.propTypes = {
  center: _propTypes.default.bool,
  dir: _propTypes.default.oneOf(['ltr', 'rtl', 'ttb', 'btt']),
  justify: _propTypes.default.oneOf(['start', 'end', 'center', 'between', 'around']),
  alignItems: _propTypes.default.oneOf(['start', 'end', 'center', 'baseline', 'stretch']),
  alignContent: _propTypes.default.oneOf(['start', 'end', 'center', 'between', 'around']),
  wrap: _propTypes.default.oneOf([true, false, 'reverse'])
};
var _default = Flex;
exports.default = _default;